import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import * as C from './components';

@NgModule({
    imports: [SharedModule, C.VersionLanguagePickerComponent],
    declarations: [C.VersionDeleteDialogComponent, C.VersionDialogComponent],
    exports: [SharedModule, C.VersionDeleteDialogComponent, C.VersionDialogComponent]
})
export class SharedMVTPModule {}
